import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mt-16">
      <div className="px-4 md:px-6 py-14 md:py-16 mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              第一时间获取最新爆料
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6">
              关注91爆料网，掌握全网最新最热爆料资讯。我们致力于为您提供真实、及时、劲爆的吃瓜内容。
            </p>
            <form className="flex flex-col sm:flex-row gap-3" data-readdy-form="true">
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱订阅爆料"
                className="flex-1 bg-foreground-800 border-b border-foreground-600 text-background-50 text-sm px-3 py-2.5 outline-none placeholder:text-foreground-400 focus:border-primary-500 transition-colors"
                required
              />
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              <button
                type="submit"
                className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                订阅 <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { to: '/', label: '首页' },
                { to: '/category/wanghong-heidiao', label: '网红黑料' },
                { to: '/category/yule-bagua', label: '娱乐八卦' },
                { to: '/category/shetuan-redian', label: '社会热点' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200 underline decoration-foreground-600 underline-offset-4"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5 text-foreground-300 text-sm">
              <p>
                <i className="ri-mail-line mr-2 text-primary-400"></i>
                hello@gm3pta.cn
              </p>
              <p>
                <i className="ri-phone-line mr-2 text-primary-400"></i>
                400-888-9191
              </p>
              <div className="mt-4">
                <h4 className="font-heading text-base font-semibold text-background-50 mb-3">公司地址</h4>
                <p className="leading-relaxed">
                  北京市朝阳区建国路88号<br />
                  SOHO现代城A座1808室
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-12 pt-8 border-t border-foreground-800">
          <div className="flex items-center gap-6 mb-4 sm:mb-0">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 text-lg"
                aria-label="社交媒体"
                rel="nofollow"
              >
                <i className={icon}></i>
              </a>
            ))}
          </div>
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 91爆料网 版权所有
          </p>
          <div className="flex items-center gap-6 mt-4 sm:mt-0">
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors duration-200 underline decoration-foreground-600 underline-offset-4" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors duration-200 underline decoration-foreground-600 underline-offset-4" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}